import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function PlayMedia(props) {
  const blue = getColorValue('illustrationAccent');
  const orange = getColorValue('illustrationOrange');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m195.96 103.181c-4.67-25.99-22.72-42-48.04-46.12-4.32-.7-8.85-1.06-13.56-1.06s-9.63.39-14.12 1.14c-25.3302 4.23-43.3502 20.21-48.0302 46.05-.79 4.37-1.2 9.01-1.2 13.93s.4 9.44 1.18 13.75c4.64 25.81 22.68 41.82 48.0502 46.05 4.49.75 9.2 1.14 14.12 1.14s9.24-.36 13.56-1.06c25.36-4.12 43.43-20.17 48.06-46.12.77-4.31 1.17-8.9 1.17-13.75s-.41-9.57-1.19-13.93z"
        fill={blue}
      />
      <path
        d="m111.311 153.282-.18-54.5203 51.97 27.0903z"
        fill={illustrationColors.staticDarkBlue}
      />
      <path d="m116.561 144.281-.18-54.5095 51.96 27.0795z" fill={orange} />
      <path d="m223.881 209.051v-9.86h-171.8801v9.86z" fill={blue} />
      <path
        d="m105.28 199.341c-1.24-6.93-6.0598-11.2-12.7998-12.29-1.15-.19-2.36-.28-3.61-.28s-2.57.1-3.76.3c-6.75 1.13-11.56 5.39-12.8 12.27-.21 1.16-.32 2.4-.32 3.71s.11 2.51.31 3.66c1.24 6.88 6.04 11.15 12.81 12.27 1.2.2 2.45.3 3.76.3s2.46-.1 3.61-.28c6.76-1.1 11.5798-5.38 12.8098-12.29.21-1.15.31-2.37.31-3.66s-.11-2.55-.32-3.71z"
        fill={orange}
      />
      <path
        d="m72.3005 199.341c-.21 1.16-.32 2.4-.32 3.71s.11 2.52.31 3.66c.15.82.35 1.59.59 2.33h31.8195c.24-.74.44-1.52.59-2.33.21-1.15.31-2.37.31-3.66s-.11-2.55-.32-3.71c0-.05-.02-.1-.03-.15h-32.9195c0 .05-.02.1-.03.15z"
        fill={illustrationColors.staticDarkBlue}
      />
    </svg>
  );
}

export default PlayMedia;
